import { Faq, IFaq } from "./faq.model";

export interface IFaqGroup {
  faqGroupId: string;
  platformId: string;
  title: string;
  status: boolean;
  sortOrder: number;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  faqs?: IFaq[];
}

export class FaqGroup {
  faqGroupId: string;
  platformId: string;
  title: string;
  status: boolean;
  sortOrder: number;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: Date;
  updatedAt: Date;
  faqs: Faq[];

  constructor(data: IFaqGroup) {
    this.faqGroupId = data.faqGroupId;
    this.platformId = data.platformId;
    this.title = data.title;
    this.status = data.status;
    this.sortOrder = data.sortOrder;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
    this.faqs = data.faqs 
      ? data.faqs.map(
          faq => new Faq(faq)
        ) 
      : [];
  }
}
